import { render, staticRenderFns } from "./RouteSetting.vue?vue&type=template&id=20e590b4&scoped=true"
import script from "./RouteSetting.vue?vue&type=script&lang=ts"
export * from "./RouteSetting.vue?vue&type=script&lang=ts"
import style0 from "./RouteSetting.vue?vue&type=style&index=0&id=20e590b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e590b4",
  null
  
)

export default component.exports